
<nav class="navbar navbar-expand-lg navbar-light bg-light header-sticky is-active-full">
    <div class="container">
        <a class="navbar-brand" routerLink="/"><img src="../assets/img/logoold.png" alt=""></a>

        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto">
                <li class="nav-item" *ngFor="let link of links">
                    <a class="nav-link" [ngClass]="link.active" href='#' *ngIf="!link.url">{{link.name}}</a>
                    <a class="nav-link" [ngClass]="link.active" href='#' *ngIf="link.url" [fragment]="link.fragment" [routerLink]="[link.url]">{{link.name}}</a>
                </li>

            </ul>
        </div>
    </div>
</nav>
